import { ACTION_TYPE, fetchJson } from '../../store/actionCreatorsHelpers';

interface Payload {
    appId: string;
    name: string;
    settingsURL: string;
}

export function openSettingsInfoPopup({ appId, name, settingsURL }: Payload) {
    return {
        type: ACTION_TYPE.OPEN_SETTINGS_INFO_POPUP,
        appId,
        payload: {
            appId,
            name,
            settingsURL,
        },
    };
}
export function fetchUserSettingsToken(appId: string) {
    return {
        type: ACTION_TYPE.REQUEST_USER_SETTINGS_TOKEN,
        payload: fetchJson(`api/userSettingsToken/${appId}`),
    };
}
export function closeSettingsInfoPopup() {
    return {
        type: ACTION_TYPE.CLOSE_SETTINGS_INFO_POPUP,
    };
}
